import React, { FC, useState } from "react";
import { Class, Teacher } from "../../../Models/Class";
import styles from "../App.module.css";
import {
  convertFrom24To12Format,
  getDurationFormat,
} from "src/Utils/DateUtils";
import Star from "src/Icons/Star.svg";
import Enroll from "./Enroll";
import TeacherModal from "./TeacherModal";

interface ListViewProps {
  classes: Class[];
  loading: boolean;
}

const GridView: FC<ListViewProps> = ({ classes, loading }) => {
  const favorite = false;
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [currentTeacher, setCurrentTeacher] = useState<Teacher>();

  let wait_list_url = '';

  classes.map((item) => {
    item.messages.map(item => {
      if(item.type === 'class-full'){
        wait_list_url = item.url;
      }
      return true;
    });
    return true;
  });

  return (
    <>
      <div className={loading ? "ContainerGrid loading" : "ContainerGrid"}>
        <TeacherModal
          modalIsOpen={isModalOpen}
          closeModal={() => {
            setModalOpen(false);
          }}
          teacher={currentTeacher}
        />
        {classes.length === 0 && loading && (
          <>
            {Array.from({ length: 9 }, (_, i) => i).map((index) => (
              <div
                className="classItem"
                key={index}
                style={{ minHeight: "439px" }}
              ></div>
            ))}
          </>
        )}
        {classes.map((item) => {
          return (
            <div className="classItem" key={item.id}>
              <span className={(item.favorite ? 'wish-list-star right active' : 'wish-list-star right') + (!item.can_enroll ? ' disabled' : '')} data-type="class" data-id={item.id} data-course={item.course.id}><span className="label"></span></span>
              <div className="titles">
                {item.messages.map((item, index) => (
                  <div key={index} className={`title ${item.type}`}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item.text,
                      }}
                    />
                  </div>
                ))}
              </div>
              <></>
              <a href={`/courses/${item.course.slug}/${item.slug}/`}>
                <img
                  className={styles.thumbnail}
                  alt="class thumnail"
                  src={item.thumbnail}
                />
              </a>
              {favorite && (
                <img src={Star} className={styles.starGrid} alt="Star" />
              )}
              <div className={styles.info}>
                <div className="start_date">
                  <span>Starts:</span>{" "}
                  <span> {getDurationFormat(item.start_date)}</span>
                </div>
                <a
                  href={`/courses/${item.course.slug}/${item.slug}/`}
                  className="class_item_title"
                >
                  {item.name}
                </a>
                {item.modality.toLowerCase() === "zoom" ||
                  item.modality.toLowerCase() === "nyc" ? (
                  <span className="class_item_modality">
                    {item.modality_url !== '' ?
                      <a href={item.modality_url} target={`_blank`}>{item.modality}</a>
                      :
                      item.modality
                    }
                    {item.start_time && item.end_time && (
                      <span className="class_item_modality_time">
                        {", "}
                        {item.days} {convertFrom24To12Format(item.start_time)} -{" "}
                        {convertFrom24To12Format(item.end_time)} ET
                      </span>
                    )}
                  </span>
                ) : (
                  <span className="class_item_modality">
                    {item.modality_url !== '' ?
                      <a href={item.modality_url} target={`_blank`}>{item.modality}</a>
                      :
                      item.modality
                    }
                    {item.modality.toLowerCase() === 'online'
                      ? `, anytime`
                      : ``
                    }
                  </span>
                )}

                <button
                  className="teacher_btn"
                  onClick={() => {
                    setCurrentTeacher(item.teacher);
                    setModalOpen(true);
                  }}
                >
                  <span className="course_teacher">{item?.teacher?.name}</span>
                </button>

                <div className="duration">
                  <span>Duration:</span>
                  <span>{item.length}</span>
                </div>
                <div className="spots-left">{item.available_spots_text}</div>
              </div>
              <div className="buttons">
                <a
                  href={`/courses/${item.course.slug}/${item.slug}/`}
                  className="learn_more_btn"
                >
                  Learn More
                </a>
                <Enroll
                  product_id={item.product_id}
                  can_enroll={item.can_enroll}
                  call={true}
                  url={wait_list_url}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default GridView;
